const Config = {
  //URL: "http://localhost:5000/",
  URL : "https://knowledge-base-article-system.vercel.app/"
};

export default Config;
